export default {
    ACTIVE_FILTER_STATES: [
        'New',
        'Used',
        'Private',
        'Company',
        'Ended',
        'Auction',
        'FixedPrice',
        'Blekinge',
        'Dalarna',
        'Gavleborg',
        'Gotland',
        'Halland',
        'Jamtland',
        'Jonkoping',
        'Kalmar',
        'Kronoberg',
        'Norrbotten',
        'Skane',
        'Sodermanland',
        'Stockholm',
        'Uppsala',
        'Varmland',
        'Vasterbotten',
        'Vastmanland',
        'VastraGotaland',
        'Orebro',
        'Ostergotland'
    ],
    MODALS: {
        FILTER_MODAL: 'filterModal',
        CATEGORY_MODAL: 'categoryModal'
    },
    ITEM_LAYOUT: {
        GRID: 'layout-grid',
        LIST: 'layout-list'
    }
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/search-results/constants/constants.js